import { SET_CLIENT_LIST, SET_CLIENT_INFO } from './constant';

const DEFAULT_STATE = {
  list: null,
  info: null
};

const clientsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_CLIENT_LIST:
      return { ...state, list: action.payload };
    case SET_CLIENT_INFO:
      return { ...state, info: action.payload };
    default:
      return state;
  }
};

export default clientsReducer;
